import { AxiosResponse } from 'axios'
import { useMutation } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'

type Params = { id: number }
type Res = Promise<AxiosResponse<{ redirect_to: string }>>

export const useDuplicateTrResume = () => {
  return useMutation({
    mutationFn: async ({ id }: Params): Res => {
      return baseClient.post(`/documents/${id}/duplicate`, { id })
    },
  })
}
